var isArray=Array.isArray;module.exports=isArray;